import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import { StageRoutingService } from "../generated/services/StageRoutingService";

import { Alert, Button } from "reactstrap";
import { AuthorisationStatus } from "../generated/models/VRP/AuthorisationStatus";
import { IconButton } from "@mui/material";
import CopyAllIcon from "@mui/icons-material/CopyAll";

export interface State {
  consentToken: string;
  loading: boolean;
  success: boolean;
  sessionToken: string;
}

export default class StageRoutingCallback extends Component<
  RouteComponentProps,
  State
> {
  constructor(props: RouteComponentProps) {
    super(props);
    const historyState = this.props.history.location.state as State;
    this.state = {
      loading: historyState?.loading ?? false,
      consentToken: null,
      success: historyState?.success ?? true,
      sessionToken: null,
    };
  }
  async componentDidMount() {
    try {
      const hashParameters = new URLSearchParams(
        this.props.location.hash.replace("#", "")
      );

      const redirectResult = await StageRoutingService.StageRouting({
        code: hashParameters.get("code"),
        id_token: hashParameters.get("id_token"),
        state: hashParameters.get("state"),
      });

      this.setState({
        consentToken: redirectResult.consentToken,
        success: redirectResult.status === AuthorisationStatus.Succeeded,
        sessionToken: redirectResult.sessionToken,
      });
    } catch (e) {
      this.setState({
        loading: false,
        success: false,
      });
    }
  }
  copyTokens = () => {
    const data = {
      consent: this.state.consentToken,
      session: this.state.sessionToken,
    };
    const dataAsJson = JSON.stringify(data);
    navigator.clipboard.writeText(dataAsJson);
  };
  renderConsentSuccessfull() {
    return (
      <div>
        <h2>Consent was succesffully created</h2>

        <br />
        <p>
          Please copy the bellow tokens and provide them to the owner of the
          mission:
        </p>
        <p>
          <small>
            Consent Token is <br></br>
            <strong>
              {this.state.consentToken?.substring(0, 100).concat("...")}
            </strong>{" "}
          </small>
          <IconButton
            onClick={() =>
              navigator.clipboard.writeText(this.state.consentToken)
            }
          >
            <CopyAllIcon />
          </IconButton>
        </p>
        <p>
          <small>
            Session Token is <br></br>
            <strong>
              {this.state.sessionToken?.substring(0, 100).concat("...")}
            </strong>{" "}
          </small>
          <IconButton
            onClick={() =>
              navigator.clipboard.writeText(this.state.sessionToken)
            }
          >
            <CopyAllIcon />
          </IconButton>
        </p>
        <div>
          <Button onClick={this.copyTokens} color="primary">
            Export tokens in JSON Format
          </Button>
        </div>
      </div>
    );
  }
  renderConsentFailed() {
    return (
      <div>
        <h2>
          Whoopsie!{" "}
          <span role="img" aria-label="*head explode*">
            🤯
          </span>
        </h2>
        <br />
        <Alert color="danger">
          Something went wrong while communicating with your provider. Please
          try starting over. If the problem persists, please let us know that
          you experienced this error.
        </Alert>
        <p>
          <small>
            Consent Token is <strong> {this.state.consentToken}</strong>{" "}
          </small>
        </p>
        <p>
          <small>
            Session Token is <strong> {this.state.sessionToken}</strong>{" "}
          </small>
        </p>
        <p>
          Consent ended up into <strong>Failed </strong> state
        </p>
      </div>
    );
  }
  render() {
    if (this.state.loading) return <p>Loading, please wait...</p>;
    if (this.state.success) return this.renderConsentSuccessfull();
    return this.renderConsentFailed();
  }
}
